import { isRefund } from "../../utils/ledger";

const PILL =
  "inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-1 rounded-full border";

/**
 * Where one payouts-ledger entry stands: a verifier's share is settled or
 * pending payout; a refund comes off the next payout or was taken off one.
 */
export function PayoutStatusPill({ entry }) {
  if (isRefund(entry)) {
    return (
      <span className={`${PILL} text-red-700 bg-red-50 border-red-200`}>
        {entry.isSettled
          ? "Refund, taken off a payout"
          : "Refund, off the next payout"}
      </span>
    );
  }
  if (entry.isSettled) {
    return (
      <span
        className={`${PILL} text-emerald-700 bg-emerald-50 border-emerald-200`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
        Settled
      </span>
    );
  }
  return (
    <span className={`${PILL} text-amber-700 bg-amber-50 border-amber-200`}>
      <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
      Pending Payout
    </span>
  );
}
